export const GLOBAL_TOAST_KEY = 'global-toast';
export const GLOBAL_CONFIRMATION_KEY = 'global-confirmation';
